import { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module7World.css';

import Learn from '../../Learn/Learn';
import Practice from './../../Unit1/Module2/ListeningPractice';
import Day4Practice from './../Day4Practice/Day4Practice';
import SingingTime from '../../SingingTime/SingingTime';
import FollowTheBeatModule7 from './../../FollowTheBeat/FollowTheBeatModule7.js';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';
import loading from './../../loading-gif-png-5.gif';

const Module7World = () => {
  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module7 } = useSelector((state) => state.module7, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  // Audio refs for iOS compatibility
  const playDogCelebrateRef = useRef(null);
  const playDiggingAudioRef = useRef(null);
  const coinAudioRef = useRef(null);
  const checkSoundRef = useRef(null);
  const rewardsFoundRef = useRef(null);
  const touchButtonRef = useRef(null);
  const buttonSoundRef = useRef(null);
  const displayVoiceRef = useRef(null);
  const prizeRef = useRef(null);
  const presentIconRef = useRef(null);

  const background = generateImageUrl('images/Module7Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+3.png');
  const background2 = generateImageUrl('images/Module2Images/U1M2_DayScene_Landscape.png');
  const animal = generateImageUrl('images/Module2Images/Dog.png');
  const dog = generateImageUrl('images/Module2Images/Dog+Still.gif');
  const progressbar0 = generateImageUrl('images/Module2Images/EmptyBone.png');
  const progressbar1 = generateImageUrl('images/Module2Images/Bone1outof3.png');
  const progressbar2 = generateImageUrl('images/Module2Images/Bone1outof3.png');
  const progressbar3 = generateImageUrl('images/Module2Images/Bone2outof3.png');
  const progressbarCompleted = generateImageUrl('images/Module2Images/Bone3outof3.png');
  const coin = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const keyReward = generateImageUrl('images/Module2Images/Bone3outof3.png');
  const dirtCloud = generateImageUrl('images/Module2Images/Dirt+cloud.png');
  const GnomeBlue = generateImageUrl('images/Module7Images/DailyReward_Gnome1.png');
  const CrystalBlue = generateImageUrl('images/Module7Images/DailyReward_Crystal_Blue.png');
  const FlowerPink = generateImageUrl('images/Module7Images/DailyReward_Flower_Pink.png');
  const FlowerBlue = generateImageUrl('images/Module7Images/DailyReward_Flower_Blue.png');
  const FairyPurple = generateImageUrl('images/Module7Images/DailyReward_Fairy1.png');
  const CrystalPurple = generateImageUrl('images/Module7Images/DailyReward_Crystal_Pink.png');
  const FireflyPink = generateImageUrl('images/Module7Images/DailyReward_Fireflies_Pink.png');
  const CrownRound = generateImageUrl('images/Module7Images/DailyReward_Frog_Crown2.png');
  const FairyGreen = generateImageUrl('images/Module7Images/DailyReward_Fairy2.png');
  const FireflyOrange = generateImageUrl('images/Module7Images/DailyReward_Fireflies_Orange.png');
  const MushroomBlue = generateImageUrl('images/Module7Images/DailyReward_Mushrooms_Blue.png');
  const MushroomPurple = generateImageUrl('images/Module7Images/DailyReward_Mushrooms_Purple.png');
  const Rock = generateImageUrl('images/Module7Images/DailyReward_MossyRock.png');
  const Log = generateImageUrl('images/Module7Images/DailyReward_Log2.png');
  const GnomeGreen = generateImageUrl('images/Module7Images/DailyReward_Gnome2.png');
  const CrownSpike = generateImageUrl('images/Module7Images/DailyReward_Frog_Crown1.png');
  const FaeDragon = generateImageUrl('images/Module7Images/BigReward_Fae_Dragon.png');
  const FaeHouse = generateImageUrl('images/Module7Images/BigReward_Fae_House.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = '5097a41c1ff268c810613f574f3d/480.m3u8';
  const present = generateImageUrl('images/Images/Gift.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);
  const [playDiggingAudio, setPlayDiggingAudio] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setdisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [day4Practice, setDay4Practice] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [displayFTB, setDisplayFTB] = useState(false);
  const [prize, setPrize] = useState(false);
  const [disPlayPrize, setDisplayPrize] = useState(false);
  const [checkStep, setCheckStep] = useState('');

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [playDogCelebrate, setPlayDogCelebrate] = useState(false);
  const [rewardAnimationState, setRewardAnimationState] = useState('');
  const [dogState, setDogState] = useState(dog);
  const [dirtState, setDirtState] = useState(false);
  const [playDigging, setPlayDigging] = useState(false);
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');

  const [amazingJobDog, setAmazingJobDog] = useState('');
  const [answerSpecialMessage, setAnswerSpecialMessage] = useState('');
  const [answerWatch, setAnswerWatch] = useState('');
  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [followTheBeatIntro, setFollowTheBeatIntro] = useState('');
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [animalClose, setAnimalClose] = useState('');
  const [animalCloseAudio, setAnimalCloseAudio] = useState('');
  const [dogDig, setDogDig] = useState('');
  const [audioReady, setAudioReady] = useState(false);
  const [userInteracted, setUserInteracted] = useState(false);
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  let influencers = [login.influencerid, login.influencerid1,login.influencerid2,login.influencerid3,login.influencerid4]

  // Handle user interaction to enable audio on iOS
  const handleUserInteraction = useCallback(() => {
    setUserInteracted(true);
  }, []);

  // iOS audio compatibility function
  const playAudioWithUserInteraction = useCallback((audioRef, onPlay, onEnded) => {
    if (audioRef && audioRef.current && userInteracted) {
      const playPromise = audioRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            if (onPlay) onPlay();
          })
          .catch((error) => {
            console.log('Audio play failed:', error);
            // Fallback: try to play on next user interaction
            if (onEnded) onEnded();
          });
      }
    }
  }, [userInteracted]);

  const playButtonAudio = useCallback(() => {
    sleep(700).then(() => {
      setButtonSound(true);
    });
  }, []);

  function getGifs() {
    setAmazingJobDog(getVideo('appfiles/answer/answer_amazing_job.gif', login));

    setDogDig(getVideo('appfiles/listening/dog_dig.gif', login));

    setCelebrateIntro(getVideo('appfiles/answer/answer_celebrate_intro.gif', login));

    setAnimalCloseAudio(getVideo('appfiles/answer/answer_day_finished.mp3', login));

    setLearnIntro(getVideo('appfiles/answer/answer_learn_intro.gif', login));

    setPracticeIntro(getVideo('appfiles/answer/answer_practice_intro.gif', login));

    setAnswerSpecialMessage(getVideo('appfiles/answer/answer_practice_special_message.gif', login));

    setAnswerWatch(getVideo('appfiles/answer/answer_practice_watch_conversation.gif', login));

    setFollowTheBeatIntro(getVideo('appfiles/answer/answer_ftb_intro.gif', login));

    setAnimalClose(getVideo('appfiles/answer/answer_day_finished.gif', login));

    setFTBInstruction(getVideo('appfiles/answer/answer_ftb_instructions.mp3', login));

    setFTBInstructionGIF(getVideo('appfiles/answer/answer_ftb_instructions.gif', login));

    setFTBMusic(getVideo('appfiles/answer/Ftb_audio_withcounting.m4a', login));

    setFTBCount(getVideo('appfiles/answer/countingDog.gif', login));

    if (!module7.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/greet/ftb_walkthrough_touch_circle.mp3', login));

      setFTBTutorial2(getVideo('appfiles/greet/ftb_walkthrough_count_touch.mp3', login));

      setFTBWalkThrough(getVideo('appfiles/answer/ftb_walkthrough_audio.mp3', login));
    }

  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  const createGameDetails = useCallback(
    (flag, reward, coin) => {
      const game_detail = module7.game_details;
      if (flag) {
        const flags = { flag, lastUpdated: new Date().toJSON() };
        game_detail.moduleFlags.psuh(flags);
      }
      if (coin >= 0) {
        game_detail.tokens_earned = coin;
      }
      if (reward) {
        const dailyRewards = [];
        for (const key in module7.rewards) {
          if (module7.rewards[key] === true) {
            const rewards = { type: key, x_multiplier: 1, y_multiplier: 1 };
            dailyRewards.push(rewards);
          }
        }
        game_detail.dailyRewards = dailyRewards;
      }
      dispatch({ type: 'MODULE7_SET_GameDetials', payload: game_detail });
    },
    [dispatch, module7.game_details, module7.rewards]
  );

  const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "Answer",
				day_completed: module7.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

  useEffect(() => {
  if((module7.reviewIcon === true || login.grade === "Teacher Mode") && module7.sectionCompleted === 4 ) {
      updateProgress();
      module7.sectionCompleted = 0;
    }
  }, [module7.sectionCompleted])

  const updateDB = useCallback(async () => {
    const myInit = {
      body: {
        id: module7.moduleID,
        day_completed: module7.day_completed,
        step_completed: module7.stepCompleted,
        game_details: JSON.stringify(module7.game_details),
      },
    };
    await API.put('TIR', '/v3/student/module', myInit)
      .then((response) => {
        if (displayGreenButton) {
          setAnimalVoice(null);
          setShowAnimal(true);
          setPlayDogCelebrate(true);
          setAnimalState(animalClose);
          setdisplayGreenButton(false);
          setDisplayReward(false);
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          module7.stepCompleted === 'notstarted' ||
          module7.stepCompleted === 'learn' ||
          module7.stepCompleted === 'practice' ||
          module7.stepCompleted === 'celebrate' ||
          module7.stepCompleted === 'followthebeat'
        ) {
          window.alert('Connection is lost. Please login again.');
          dispatch({ type: 'CLEAR' });
          Auth.signOut();
          navigate('/');
        }
      });
      const myInit2 = {
        body: {
          id: login.studentid,
          current_module: 'Answer',
        },
      };
      await API.put('TIR', '/v3/student', myInit2)
      .then((response) => {
      })
      .catch((error) => {
      });
  });

  useEffect(() => {
    getGifs();
  },[]);

  // iOS audio compatibility - trigger audio playback when state changes
  useEffect(() => {
    if (playDogCelebrate && playDogCelebrateRef.current) {
      playAudioWithUserInteraction(
        playDogCelebrateRef,
        () => setAudioReady(true),
        () => {
          setPlayDogCelebrate(false);
          module7.currentday === 8
            ? closeDay8Video()
            : navigate('/answer/navigation');
        }
      );
    }
  }, [playDogCelebrate, playAudioWithUserInteraction]);

  useEffect(() => {
    if (playDiggingAudio && playDiggingAudioRef.current) {
      playAudioWithUserInteraction(
        playDiggingAudioRef,
        () => {
          setDirtState(true);
          setAudioReady(true);
        },
        () => {
          setAudioReady(false);
          setPlayDigging(false);
          setDirtState(false);
          setPlayDiggingAudio(false);
          setKeyIcon(false);
          setDisplayReward(true);
          setRewardsFound(true);
        }
      );
    }
  }, [playDiggingAudio, playAudioWithUserInteraction]);

  useEffect(() => {
    if (coinAudio && coinAudioRef.current) {
      playAudioWithUserInteraction(
        coinAudioRef,
        null,
        () => {
          dispatch({ type: 'MODULE7_SET_COIN', payload: module7.coins + 1 });
          setCoinAudio(false);
          setCoinAnimationState('bounceIcons');
          setCoinIcon(false);
          playButtonAudio();
        }
      );
    }
  }, [coinAudio, playAudioWithUserInteraction, dispatch, module7.coins, playButtonAudio]);

  useEffect(() => {
    if (checkSound && checkSoundRef.current) {
      playAudioWithUserInteraction(
        checkSoundRef,
        null,
        () => setCheckSound(false)
      );
    }
  }, [checkSound, playAudioWithUserInteraction]);

  useEffect(() => {
    if (rewardsFound && rewardsFoundRef.current) {
      playAudioWithUserInteraction(rewardsFoundRef);
    }
  }, [rewardsFound, playAudioWithUserInteraction]);

  useEffect(() => {
    if (touchButton && touchButtonRef.current) {
      playAudioWithUserInteraction(
        touchButtonRef,
        null,
        () => setTouchButton(false)
      );
    }
  }, [touchButton, playAudioWithUserInteraction]);

  useEffect(() => {
    if (buttonSound && buttonSoundRef.current) {
      playAudioWithUserInteraction(
        buttonSoundRef,
        null,
        () => setButtonSound(false)
      );
    }
  }, [buttonSound, playAudioWithUserInteraction]);

  useEffect(() => {
    if (displayVoice && displayVoiceRef.current) {
      playAudioWithUserInteraction(
        displayVoiceRef,
        () => setAudioReady(true),
        () => {
          setAudioReady(false);
          setDisplayVoice(false);
          setShowAnimal(false);
        }
      );
    }
  }, [displayVoice, playAudioWithUserInteraction]);

  useEffect(() => {
    if (prize && prizeRef.current) {
      playAudioWithUserInteraction(prizeRef);
    }
  }, [prize, playAudioWithUserInteraction]);

  useEffect(() => {
    if (presentIcon && presentIconRef.current) {
      playAudioWithUserInteraction(presentIconRef);
    }
  }, [presentIcon, playAudioWithUserInteraction]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module7.stepCompleted]);

  useEffect(() => {
    if (module7.coins >= 100) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module7.coins);
      updateDB();
    }
  }, [module7.coins]);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (module7.currentday <= module7.day_completed  || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE7_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE7_SET_KEY', payload: 4 });
      if (module7.currentday === 4 || module7.currentday === 8) {
        dispatch({ type: 'MODULE7_SET_KEY', payload: 5 });
      }
    } else {
      if (module7.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE7_TOGGLE_REVIEW_ICON', payload: false });
      if (module7.currentday === 4 && module7.day_completed === 3) {
        if (module7.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE7_SET_KEY', payload: 0 });

        } else if (module7.stepCompleted === 'singingtime') {
          dispatch({ type: 'MODULE7_SET_KEY', payload: 1 });

        } else if (module7.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE7_SET_KEY', payload: 2 });

        } else if (module7.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE7_SET_KEY', payload: 3 });

        } else if (module7.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE7_SET_KEY', payload: 4 });

        } else if (module7.stepCompleted === 'celebrate') {
          setKeyIcon(true);
          dispatch({ type: 'MODULE7_SET_KEY', payload: 5 });

        }
        playButtonAudio();
      } else {
        if (module7.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE7_SET_KEY', payload: 0 });

        } else if (module7.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE7_SET_KEY', payload: 1 });

        } else if (module7.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE7_SET_KEY', payload: 2 });

        } else if (module7.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE7_SET_KEY', payload: 3 });

        } else if (module7.stepCompleted === 'celebrate') {
          if (module7.currentday === 8 && module7.day_completed === 7) {
            dispatch({ type: 'MODULE7_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE7_SET_KEY', payload: 4 });
          }
        } else if (module7.stepCompleted === 'surprise') {
          dispatch({ type: 'MODULE7_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module7.stepCompleted]);

  const selectReward = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                handleUserInteraction();
                dispatch({
                  type: `MODULE7_SET_REWARD${module7.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE7_SET_REWARD${module7.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setdisplayGreenButton(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                handleUserInteraction();
                dispatch({
                  type: `MODULE7_SET_REWARD${module7.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE7_SET_REWARD${module7.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setdisplayGreenButton(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                handleUserInteraction();
                setCheckSound(true);
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE7_SET_DAY_UNLOCK${module7.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE7_SET_dayCompleted',
                    payload: module7.currentday === 8 ? 9 : module7.currentday,
                  });
                  dispatch({
                    type: 'MODULE7_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={FaeDragon}
              alt=''
              onClick={() => {
                handleUserInteraction();
                dispatch({ type: `MODULE7_SET_PRIZE1`, payload: true });
                dispatch({ type: `MODULE7_SET_PRIZE2`, payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setdisplayGreenButton(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={FaeHouse}
              alt=''
              onClick={() => {
                handleUserInteraction();
                dispatch({ type: `MODULE7_SET_PRIZE2`, payload: true });
                dispatch({ type: `MODULE7_SET_PRIZE1`, payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setdisplayGreenButton(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                handleUserInteraction();
                setCheckSound(true);
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE7_SET_COIN',
                    payload: module7.coins - 100,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module7.currentday) {
      case 1:
        setRewardOption1(MushroomPurple);
        setRewardOption2(MushroomBlue);
        break;
      case 2:
        setRewardOption1(FlowerPink);
        setRewardOption2(FlowerBlue);
        break;
      case 3:
        setRewardOption1(Rock);
        setRewardOption2(Log);
        break;
      case 4:
        setRewardOption1(GnomeGreen);
        setRewardOption2(GnomeBlue);
        break;
      case 5:
        setRewardOption1(CrownSpike);
        setRewardOption2(CrownRound);
        break;
      case 6:
        setRewardOption1(CrystalPurple);
        setRewardOption2(CrystalBlue);
        break;
      case 7:
        setRewardOption1(FireflyOrange);
        setRewardOption2(FireflyPink);
        break;
      case 8:
        setRewardOption1(FairyPurple);
        setRewardOption2(FairyGreen);
        break;
      default:
        setdisplayGreenButton(true);
        break;
    }
  }, [
    keyIcon,
    CrownRound,
    CrownSpike,
    CrystalBlue,
    CrystalPurple,
    FairyGreen,
    FairyPurple,
    FireflyOrange,
    FireflyPink,
    FlowerBlue,
    FlowerPink,
    GnomeBlue,
    GnomeGreen,
    Log,
    MushroomBlue,
    MushroomPurple,
    Rock,
    module7.currentday,
  ]);

  const displayReview = () => {
    if (module7.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                handleUserInteraction();
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                handleUserInteraction();
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                handleUserInteraction();
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                handleUserInteraction();
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                handleUserInteraction();
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                handleUserInteraction();
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                handleUserInteraction();
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                handleUserInteraction();
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                handleUserInteraction();
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/answer/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module7.currentday === 4) {
              dispatch({ type: 'MODULE7_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module7.day_completed === 9) {
              navigate('/answer/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/answer/answer_full_song_example.m4a', login);
    let video = getVideo(`appfiles/answer/learn_video.mp4`, login);
    switch (module7.currentday) {
      case 1:
        setLearn(
          <Learn
            video='06aba8537fdea3b907bc8707a1b8/480.m3u8'
            songVideo={video}
            closingVideo='4fefb0deec697df8605aacb25733/480.m3u8'
            destiny='/answer'
            song={song}
            back='/answer'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE7_SET_stepCompleted'
            module={module7}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='ace9690f6f03005d9636692b6cc6/480.m3u8'
            songVideo={video}
            closingVideo='da0ea6112393b8d580c07fa28dbd/480.m3u8'
            destiny='/answer'
            song={song}
            back='/answer'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE7_SET_stepCompleted'
            module={module7}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='b9fcbf69b4342b7e6b28b1cbc0ca/480.m3u8'
            songVideo={video}
            closingVideo='7a46cc8ccaf665298bb8a0e0920b/480.m3u8'
            destiny='/answer'
            song={song}
            back='/answer'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE7_SET_stepCompleted'
            module={module7}
          />
        );
        break;
      default:
        setShowAnimal(true);
        setAnimalState(learnIntro);
        setAnimalVoice(getVideo('appfiles/answer/answer_learn_intro.mp3', login));
        // setDisplayVoice(true)
        await GetUserVideo(`userfiles/${module7.StudentID}/answer_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module7.currentday-4]}/answer_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/answer'
                    song={data}
                    back='/answer'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE7_SET_stepCompleted'
                    module={module7}
                    instrumental={getVideo('appfiles/answer/answer_full_song.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/answer'
                    song={song}
                    back='/answer'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE7_SET_stepCompleted'
                    module={module7}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    const text = [
      'Say, "My favorite color is ________."',
      'Say, "My favorite animal is ________."',
      'Say, "My favorite food is ________."',
      'Say, "My favorite game is ________."',
      'Say, "My favorite thing to do outside is ________."',
    ];
    switch (module7.currentday) {
      case 1:
        setDisplayPractice(true);
        break;
      case 2:
        setDisplayPractice(true);
        break;
      case 3:
        setDisplayPractice(true);
        break;
      default:
        const introVideo = 'ae17b215c914c6dd97c61e0c9b76/480.m3u8';
        let question = getVideo(`appfiles/answer/answer_question_${module7.currentday + 1}.mp4`, login);
        let voice1 = getVideo(`appfiles/answer/answer_practice_record_${module7.currentday + 1}.mp3`, login);
        let voice2 = getVideo('appfiles/answer/answer_practice_special_message.mp3', login);
        let voice3 = getVideo('appfiles/answer/answer_practice_watch_conversation.mp3', login);
        let voice4 = getVideo('appfiles/answer/answer_amazing_job.mp3', login);
        let greeting = getVideo(`appfiles/answer/answer_greeting_${module7.currentday + 1}.mp4`, login);
        let acknowledge = getVideo(`appfiles/answer/answer_acknowledge_${module7.currentday + 1}.mp4`, login);
        setShowAnimal(true);
        setAnimalState(practiceIntro);
        setAnimalVoice(getVideo('appfiles/answer/answer_practice_intro.mp3', login));
        // setDisplayVoice(true)
        GetUserVideo(`influencers/${influencers[module7.currentday-4]}/answer_video_message.mp4`).then((influencerVideo) => {
          GetUserVideo(`userfiles/${module7.StudentID}/greet_practice_video_${module7.currentday + 1}.mp4`).then((greetingResponse) => {
            setDay4Practice(
              <Day4Practice
                module={module7}
                celebrateVideo={introVideo}
                greetingResponse={greetingResponse}
                background={background}
                question={question}
                influencerVideo={influencerVideo}
                text={text[module7.currentday - 4]}
                voice1={voice1}
                voice2={voice2}
                voice3={voice3}
                voice4={voice4}
                animate2={answerSpecialMessage}
                animate3={answerWatch}
                animate4={amazingJobDog}
                name={`answer_practice_video_${module7.currentday + 1}.mp4`}
                greeting={greeting}
                acknowledge={acknowledge}
                animal={animal}
                setDisplayDay4Practice={setDisplayDay4Practice}
                moduleNum={'MODULE7'}
              />
            );
          });
        });
        setDisplayDay4Practice(true);
        break;
    }
  };
  const openFTB = async () => {
    switch (module7.currentday) {
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;
      default:
        setShowAnimal(true);
        setAnimalState(followTheBeatIntro);
        setAnimalVoice(getVideo('appfiles/answer/answer_ftb_intro.mp3', login));
        break;
        // setDisplayVoice(true)
    }
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = 'e6d3d358f8076cf19125fb8719c4/480.m3u8';
    const celebrateVideo2 = '008540366ca45c461508fce48d94/480.m3u8';
    const celebrateVideo3 = 'eda303588660bfa9b05f43ec2bf9/480.m3u8';

    switch (module7.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module7}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE7'}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module7}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE7'}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module7}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE7'}
          />
        );
        break;
      default:
        let voice1 = getVideo('appfiles/answer/answer_celebrate_record_amazing.mp3', login);
        let voice2 = getVideo('appfiles/answer/answer_celebrate_say_thanks.mp3', login);
        let voice3 = getVideo('appfiles/answer/answer_amazing_job.mp3', login);
        setShowAnimal(true);
        setAnimalVoice(getVideo('appfiles/answer/answer_celebrate_intro.mp3', login));
        // setDisplayVoice(true)
        setAnimalState(celebrateIntro);
        GetUserVideo(`influencers/${influencers[module7.currentday-4]}/answer_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              module={module7}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              text={'Record yourself in an excited voice and say, "I am amazing!"'}
              name={`answer_celebration_surprise_${module7.currentday + 1}.mp4`}
              influencerVideo={influencerVideo}
              animation={amazingJobDog}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={'MODULE7'}
            />
          );
        });
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = '1f65b2d92c5fc26441ac9366851c/480.m3u8';
    let noteVideo = getVideo('appfiles/answer/answer_student_notes.mp4', login);
    let singingMusic = getVideo('appfiles/answer/answer_student_sing_along.m4a', login);
    let instrumental = getVideo('appfiles/answer/answer_student.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module7}
        moduleNum='MODULE7'
        name='answer'
        instrumental={instrumental}
        instrumentalURL={'appfiles/answer/answer_full_song.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `influencers/${login.influencerid}/answer_affirmation.mp4`,
      },
      {
        video: `userfiles/${module7.StudentID}/answer_celebration_surprise_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/answer_affirmation.mp4`,
      },
      {
        video: 'appfiles/answer/answer_greeting_5.mp4',
      },
      {
        video: `userfiles/${module7.StudentID}/greet_practice_video_5.mp4`,
      },
      {
        video: 'appfiles/answer/answer_question_5.mp4',
      },
      {
        video: `userfiles/${module7.StudentID}/answer_practice_video_5.mp4`,
      },
      {
        video: `appfiles/answer/answer_acknowledge_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/answer_video_message.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/answer_affirmation.mp4`,
      },
      {
        video: `userfiles/${module7.StudentID}/answer_celebration_surprise_9.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/answer_affirmation.mp4`,
      },
    ];

    for (let i = 0; i < usePhoto.length; i++) {
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }
    
    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/answer/answer_full_song_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });
    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const keyAnimation = () => {
    setRewardAnimationState('fade-out');
    sleep(1000).then(() => {
      diggingAnimation();
    });
  };

  const diggingAnimation = () => {
    setPlayDigging(true);
  };

  const closeDay8Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setShowAnimal(false);
    setIntroVideo(AfterCelebrateVideo9);
  };

  return (
    <>
      {playDogCelebrate && (
        <audio
          ref={playDogCelebrateRef}
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setPlayDogCelebrate(false);
            module7.currentday === 8
              ? closeDay8Video()
              : navigate('/answer/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}
      {playDiggingAudio && (
        <audio
          ref={playDiggingAudioRef}
          onPlay={() => {
            setDirtState(true);
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setPlayDigging(false);
            setDirtState(false);
            setPlayDiggingAudio(false);
            setKeyIcon(false);
            setDisplayReward(true);
            setRewardsFound(true);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module2Videos/dog_digging.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {coinAudio && (
        <audio
          ref={coinAudioRef}
          onEnded={() => {
            dispatch({ type: 'MODULE7_SET_COIN', payload: module7.coins + 1 });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {checkSound && (
        <audio
          ref={checkSoundRef}
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {rewardsFound && (
        <audio
          ref={rewardsFoundRef}
        >
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          ref={touchButtonRef}
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          ref={buttonSoundRef}
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}

      {displayVoice && (
        <audio
          ref={displayVoiceRef}
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setShowAnimal(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}

      {displayIntroVideo && introduction()}
      {!showAnimal && displayLearn && learn}
      {!showAnimal && displayDay4Practice && day4Practice}
      {displayPractice && (
        <Practice
          world2={true}
          setDisplayPractice={setDisplayPractice}
          background={background2}
          stepComplete={'MODULE7_SET_stepCompleted'}
          module={module7}
        />
      )}
      {!showAnimal && displayFTB && (
        <FollowTheBeatModule7
          setDisplayFTB={setDisplayFTB}
          awesomeJob={amazingJobDog}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={'MODULE7_SET_stepCompleted'}
          module={module7}
          score={'ftb_answer'}
        />
      )}
      {displaySingingTime && singTime}
      {!showAnimal && displayCelebrate && celebrate}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showAnimal) && (
        <div
          className='answerWorldBody'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module7Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+3.png')
            })`,
          }}
          onClick={handleUserInteraction}
          onTouchStart={handleUserInteraction}
        >
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={(e) => {
                handleUserInteraction();
                togglePopup();
              }}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world'
              onClick={() => {
                handleUserInteraction();
                navigate('/answer/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio
              ref={prizeRef}
            >
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                handleUserInteraction();
                setPrize(false);
                setDisplayPrize(true);
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                handleUserInteraction();
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {disPlayPrize && openPrize()}

          <img className='dogGif' src={dogState} alt='dog Icon' />
          {showAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {showAnimal && (
            <img
              alt=''
              style={audioReady ? {} : { display: 'none' }}
              src={animalState}
              className='dogGif'
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowAnimal(false)}
            />
          )}
          {playDigging && (
            <img
              alt=''
              style={audioReady ? {} : { display: 'none' }}
              src={dogDig}
              className='dogGif'
              onLoad={() => setPlayDiggingAudio(true)}
            />
          )}
          {dirtState && (
            <img
              className='dirt'
              alt=''
              src={dirtCloud}
              id='dirtAnimation'
              style={{
                position: 'absolute',
                zIndex: 2,
                top: '70%',
                left: '50%',
                height: '120px',
                width: '140px',
                marginTop: '90px',
                marginLeft: '-70px',
              }}
            ></img>
          )}

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'
            />
            {module7.coins < 10 && (
              <h5 className='scoretext1'>{module7.coins}</h5>
            )}
            {module7.coins >= 10 && module7.coins < 100 && (
              <h5 className='scoretext10'>{module7.coins}</h5>
            )}
            {module7.coins >= 100 && (
              <h5 className='scoretext100'>{module7.coins}</h5>
            )}
            <p className='scoretext'>100</p>
          </div>

          {module7.currentday === 4 || module7.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys5[module7.keys]}
                alt='crab Icon'
              />
              <h3 className='progresstext3'>{module7.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys4[module7.keys]}
                alt='crab Icon'
              />
              <h3 className='progresstext3'>{module7.keys}/4</h3>
            </div>
          )}

          {!showAnimal && !module7.reviewIcon && !coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {module7.currentday === 4 &&
                module7.stepCompleted === 'notstarted' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={SingingTimeIcon}
                    alt='learn button'
                    onClick={() => {
                      handleUserInteraction();
                      setTouchButton(true);
                      sleep(500).then(() => {
                        displaySinging();
                        setCheckStep('singingtime');
                      });
                    }}
                  />
                )}
              {module7.currentday !== 4 &&
                module7.stepCompleted === 'notstarted' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='learn button'
                    onClick={() => {
                      handleUserInteraction();
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openLearn();
                        setCheckStep('learn');
                      });
                    }}
                  />
                )}

              {module7.stepCompleted === 'learn' && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={practiceBtn}
                  alt='practice button'
                  onClick={() => {
                    handleUserInteraction();
                    touchSound.play()
                    sleep(500).then(() => {
                      openPractice();
                      setCheckStep('practice');
                    });
                  }}
                />
              )}
              {module7.stepCompleted === 'practice' && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={ftbBtn}
                  alt='celebrate button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(500).then(() => {
                      openFTB();
                      setCheckStep('followthebeat');
                    });
                  }}
                />
              )}
              {module7.stepCompleted === 'followthebeat' && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={celebrateBtn}
                  alt='celebrate button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(500).then(() => {
                      openCelebrate();
                      setCheckStep('celebrate');
                    });
                  }}
                />
              )}
              {module7.stepCompleted === 'singingtime' && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={learnBtn}
                  alt='singing button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(500).then(() => {
                      openLearn();
                      setCheckStep('learn');
                    });
                  }}
                />
              )}
            </div>
          )}

          {!displayVoice && coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {!module7.reviewIcon && (
                <img
                  className='chooseReward'
                  id={coinAnimationState}
                  src={coin}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                  }}
                  onClick={() => {
                    handleUserInteraction();
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!disPlayPrize &&
            !showAnimal &&
            !displayReward && (
              <div className='actionBtnDiv'>
                {module7.reviewIcon && (
                <img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    setReviewIcon(!reviewIcon);
                  }}
                />)}
                {showReward && (
                  <img
                    src={rewardBtn}
                    className='actionBtn4'
                    alt='review button'
                                      onClick={() => {
                    handleUserInteraction();
                    setTouchButton(true);
                    sleep(500).then(() => {
                      keyAnimation();
                    });
                  }}
                />)}
                {module7.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {keyIcon && !coinIcon && !disPlayPrize && (
            <img
              className='rewardsIcon'
              style={{
                width: '150px',
                height: '50px',
                marginLeft: '-75px',
                zIndex: 10,
              }}
              id={rewardAnimationState}
              src={keyReward}
              alt='reward bone'
              onClick={() => {
                handleUserInteraction();
                keyAnimation();
              }}
            />
          )}
          {displayReward && selectReward()}

          {!disPlayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                handleUserInteraction();
                playSurpriseVideo();
              }}
            />
          )}
          {!disPlayPrize && !coinIcon && presentIcon && (
            <audio
              ref={presentIconRef}
            >
              <source src={presentSound}></source>
            </audio>
          )}

          {module7.rewards.GnomeBlue && (
            <img className='GnomeBlue' src={GnomeBlue} alt='' />
          )}
          {module7.rewards.GnomeGreen && (
            <img className='GnomeGreen' src={GnomeGreen} alt='' />
          )}
          {module7.rewards.CrystalBlue && (
            <img className='CrystalBlue' src={CrystalBlue} alt='' />
          )}
          {module7.rewards.FlowerPink && (
            <img className='FlowerPink' src={FlowerPink} alt='' />
          )}
          {module7.rewards.FlowerBlue && (
            <img className='FlowerBlue' src={FlowerBlue} alt='' />
          )}
          {module7.rewards.FairyPurple && (
            <img className='FairyPurple' src={FairyPurple} alt='' />
          )}
          {module7.rewards.CrystalPurple && (
            <img className='CrystalPurple' src={CrystalPurple} alt='' />
          )}
          {module7.rewards.FireflyPink && (
            <img className='FireflyPink' src={FireflyPink} alt='' />
          )}
          {module7.rewards.CrownRound && (
            <img className='CrownRound' src={CrownRound} alt='' />
          )}
          {module7.rewards.FairyGreen && (
            <img className='FairyGreen' src={FairyGreen} alt='' />
          )}
          {module7.rewards.FireflyOrange && (
            <img className='FireflyOrange' src={FireflyOrange} alt='' />
          )}
          {module7.rewards.MushroomBlue && (
            <img className='MushroomBlue' src={MushroomBlue} alt='' />
          )}
          {module7.rewards.MushroomPurple && (
            <img className='MushroomPurple' src={MushroomPurple} alt='' />
          )}
          {module7.rewards.Rock && <img className='Rock' src={Rock} alt='' />}
          {module7.rewards.Log && <img className='Log' src={Log} alt='' />}
          {module7.rewards.CrownSpike && (
            <img className='CrownSpike' src={CrownSpike} alt='' />
          )}
          {module7.rewards.FaeDragon && (
            <img className='FaeDragon' src={FaeDragon} alt='' />
          )}
          {module7.rewards.FaeHouse && (
            <img className='FaeHouse' src={FaeHouse} alt='' />
          )}
        </div>
      )}
    </>
  );
};
export default Module7World;
